<div class="recentSystem">
  <div
    class="advanced-search-btn"
    role="button"
    tabindex="0"
    (keydown.enter)="routeToAdvancedSearch()"
    (click)="routeToAdvancedSearch()"
  >
    <div class="advanced-search-content">
      <sh-icon icon="filter-search"></sh-icon>
      <sh-text class="advance-search-text" size="body-2">
        Advanced Search
      </sh-text>
    </div>
  </div>
  <div class="history" id="searchHistory" #searchHistory>
    <ng-container *ngIf="items$ | async as items">
      <div *ngIf="items.length > 0" class="recent-searches-title">
        Recent Searches:
      </div>
      <div
        role="group"
        class="systems"
        #system
        *ngIf="items.length > 0; else noItems"
      >
        <ng-container *ngFor="let item of items; let i = index">
          <ng-container
            *ngTemplateOutlet="
              (layout.desktopAny$ | async) ? itemDesktop : itemDesktop;
              context: { $implicit: item, index: i }
            "
          >
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #noItems>
      <div class="no-recent-systems">
        - no systems found -<br />
        (consider including more modalities above)
      </div>
    </ng-template>
  </div>
</div>

<!-- wide item (desktop) -->
<ng-template #itemDesktop let-item let-index="index">
  <div class="system-container">
    <!-- sh-icon icon="time" size="s" class="time"></sh-icon -->
    <sh-icon
      [icon]="item.bookmark ? 'favorite' : 'favorite-off'"
      size="s"
      sh-scale="s"
      favorite
      [id]="'fav' + item._key"
      role="option"
      aria-selected="false"
      tooltip="Favorite"
      tabindex=""
      class="bookmark"
      [attr.aria-label]="
        item.bookmark ? 'Remove from Favorites' : 'Save to Favorites'
      "
      [attr.bookmarked]="item.bookmark || null"
      (click)="
        toggleBookmark(item); $event.preventDefault(); $event.stopPropagation()
      "
    ></sh-icon>
    <div
      role="option"
      [attr.aria-label]="
        item.unsupported
          ? 'Unsupported System:'
          : '' +
            resolveModality(item.modalityId, modalities$ | async) +
            '. System Material Nr:' +
            item.systemMaterialNumber
      "
      aria-selected="false"
      [attr.data-index]="index"
      keyboard-focusable
      class="system"
      [id]="'item' + item._key"
      [ngClass]="{
        'unsupported-system': item.unsupported,
      }"
      (click)="goToSystem(item)"
      (keyup.enter)="goToSystem(item)"
      tabindex="0"
    >
      <div class="row1 truncate title">
        <span class="modality" aria-hidden="true"
          >{{ resolveModality(item.modalityId, modalities$ | async) }}
        </span>
        <span
          class="truncate serial-number"
          [innerHTML]="highlight(item, 'systemSerialNumber') | sanitizeHtml"
        ></span>
        <span class="unsupported">{{
          'unsupported' | translate | uppercase
        }}</span>
      </div>
      <div
        class="row2 truncate title"
        [innerHTML]="highlight(item, 'systemName') | sanitizeHtml"
      >
        {{ item.systemName }}
      </div>

      <div class="row1 truncate func-loc">Functional Loc.</div>
      <div
        class="row2 truncate func-loc"
        [innerHTML]="highlight(item, 'functionalLocation') | sanitizeHtml"
      >
        {{ item.functionalLocation }}
      </div>

      <div class="row1 truncate mat-nr">Material No.</div>
      <div
        class="row2 truncate mat-nr"
        [innerHTML]="highlight(item, 'systemMaterialNumber') | sanitizeHtml"
      >
        {{ item.systemMaterialNumber }}
      </div>

      <div class="row1 truncate costumer-name">Customer Name</div>
      <div
        class="row2 truncate costumer-name"
        [innerHTML]="highlight(item, 'customerName') | sanitizeHtml"
      ></div>

      <div class="row1 truncate costumer-city">Country and City</div>
      <div
        class="row2 truncate costumer-city"
        [innerHTML]="highlight(item, 'customerLocation') | sanitizeHtml"
      ></div>

      <div class="row1 truncate equipment-tech-id">Equipment Tech ID</div>
      <div
        class="row2 truncate equipment-tech-id"
        [innerHTML]="highlight(item, 'equipmentTechId') | sanitizeHtml"
      ></div>

      <div class="row1 truncate equipment-id">Equipment ID</div>
      <div
        class="row2 truncate equipment-id"
        [innerHTML]="highlight(item, 'equipmentId') | sanitizeHtml"
      ></div>
    </div>
  </div>
</ng-template>
